import gql from "graphql-tag";

/**
 * GraphQL Mutations for user authentication
 */

const loginMutation = gql`
  mutation($data: LoginInput!) {
    login(data: $data) {
      access_token
      refresh_token
      expires_in
      token_type
      user {
        id
        user_name
        full_name
        email
        port {
          id
          name
          description
        }
      }
      roles
    }
  }
`;

const signupMutation = gql`
 mutation($input: ShipperUserCreationInput!){
CreateShipperUser(input: $input) {
  full_name
 }
}
 `

export default {
  loginMutation, signupMutation
};
